module.exports = __webpack_public_path__ + "static/media/Akamai.9a119cb9.svg";